/**
 * Badge per lo stato di un cliente (lead / active / inactive / archived).
 * I colori seguono la convenzione semantic del tema.
 */

export const STATUS_CONFIG = {
  lead:     { label: 'Lead',     className: 'badge-warning', icon: '⏳' },
  active:   { label: 'Attivo',   className: 'badge-success', icon: '✅' },
  inactive: { label: 'Inattivo', className: 'badge-muted',   icon: '⚪' },
  archived: { label: 'Archiviato', className: 'badge-muted', icon: '📦' },
};

export default function StatusBadge({ status, small }) {
  const cfg = STATUS_CONFIG[status] || { label: status, className: 'badge-muted' };
  return (
    <span className={`badge ${cfg.className}`}>
      {!small && <span className="mr-1">{cfg.icon}</span>}
      {cfg.label}
    </span>
  );
}
